import http from "@/utilities/request/https";
import { apiUrl } from "./apiURL";
import store from "@/store";
import { getLocalStorage, getQueryVariable, localData, setLocalStorage } from "@/utilities/common";
import eventBus from "@/utilities/eventBus";

const api = {
  getUserInfo () {
    return new Promise((resolve) => {
      const { userStore } = store;
      if (getQueryVariable("code") && getQueryVariable("state")) {
        if (localData("userInfo") && getLocalStorage("token")) {
          userStore.setUserInfo({ ...localData("userInfo") });
          api.getAccessToken(localData("userInfo"), resolve);
        } else {
          let data: { code: string | boolean; state: string | boolean; redirectUri?: string } = {
            code: getQueryVariable("code"),
            state: getQueryVariable("state")
          };
          data = process.env.NODE_ENV === "development" ? { ...data, redirectUri: process.env.REDIRECTURL } : { ...data };
          api.CrossBorder.getUserInfo(data).then((res: any) => {
            if ((res && res.status === 200) || getLocalStorage("userInfo")) {
              userStore.setUserInfo({ ...res.userInfoVo, accountUsername: res?.userInfoVo?.mail, isAgreement: res?.isAgreement });
              setLocalStorage("IsAgreement", res.isAgreement);
              api.getAccessToken({ ...res.userInfoVo, accountUsername: res?.userInfoVo?.mail, accessToken: res?.bzaTokenVo?.accessToken }, resolve);
            }
          });
        }
      } else {
        if (getLocalStorage("userInfo") !== null && JSON.parse(getLocalStorage("userInfo") || "{}")?.id) {
          const res = JSON.parse(getLocalStorage("userInfo") || "{}");
          api.getAccessToken({ ...res, accountUsername: res?.mail ?? res?.userPrincipalName, accessToken: res?.accessToken }, resolve);
          userStore.setUserInfo({ ...res, accountUsername: res?.mail ?? res?.userPrincipalName });
          // api.CrossBorder.refreshUserInfo({
          //   email: JSON.parse(getLocalStorage("userInfo") || "{}")?.mail,
          // }).then((res: any) => {
          //   debugger;
          //   api.getAccessToken({ ...res, accountUsername: res?.mail ?? res?.userPrincipalName, accessToken: JSON.parse(getLocalStorage("userInfo") || "{}")?.accessToken }, resolve);
          //   if (res && res.status === 200) {
          //     userStore.setUserInfo({ ...res, accountUsername: res?.mail ?? res?.userPrincipalName });
          //   }
          // });
        }
      }
      // else {
      //   if (getLocalStorage("userInfo") !== null && JSON.parse(getLocalStorage("userInfo") || "{}")?.id) {
      //     api.CrossBorder.refreshUserInfo({
      //       email: JSON.parse(getLocalStorage("userInfo") || "{}")?.mail,
      //     }).then((res: any) => {
      //       debugger;
      //       api.getAccessToken({ ...res, accountUsername: res?.mail ?? res?.userPrincipalName, accessToken: JSON.parse(getLocalStorage("userInfo") || "{}")?.accessToken }, resolve);
      //       if (res && res.status === 200) {
      //         userStore.setUserInfo({ ...res, accountUsername: res?.mail ?? res?.userPrincipalName });
      //       }
      //     });
      //   }
      // }
      /* msalInstance.handleRedirectPromise().then((res:any) => {
        console.log(res, "res");
        if (res || (getLocalStorage("userInfo") && localData("userInfo").token)) {
          callMsGraph(res ? res.accessToken : localData("userInfo").token).then((response:any) => {
            userStore.setUserInfo({ ...response, ...{ token: res ? res.accessToken : localData("userInfo").token, accountUsername: res?.account?.username } });
            response.accountUsername = res?.account?.username;
            if (response && response.id && response.mail && response.accountUsername) {
              setTimeout(() => {
                api.getAccessToken(response, resolve);
              }, 200);
            } else {
              msalInstance.loginRedirect({
                prompt: "create",
                scopes: ["user.read"]
              });
            }
          });
        }
      }); */
    });
  },
  getAccessToken (response: any, resolve?: any) {
    const { userStore } = store;
    userStore.setToken(response.accessToken);
    resolve && resolve({
      data: Object.assign({
        userId: response.id,
        nickName: response.givenName,
      }, response)
    });
    eventBus.emit("getAccessToken", { token: response.accessToken });
    /* if (response && response.id && response.mail && response.accountUsername) {
      const data = {
        msaId: response?.id,
        email: response?.accountUsername,
        issuer: "Issuer",
        audience: "Audience",
        sourcekey: process.env.SOURCEKEY
      };
      api.AccessToken.AccessTokenGenerate(data).then((res:any) => {
        userStore.setToken(res.accessToken);
        resolve && resolve({
          data: Object.assign(
            {
              userId: response.id,
              nickName: response.givenName,
            },
            response,
          ),
        });
        eventBus.emit("getAccessToken", { token: res.accessToken });
      });
    } */
  },
  AccessToken: {
    AccessTokenGenerate: (data:any) => http("post", apiUrl.AccessToken.AccessTokenGenerate, data),
  },
  User: {
    pushMSAInfo: (data:any) => http("post", apiUrl.AccountApiList.uploadMSALInfo, data),
    Invitation: (data:any) => http("post", apiUrl.Invitation.invitation, data),
    InvitationAccept: (data:any) => http("post", apiUrl.Invitation.acceptanceInvitation, data),
    InvitationCheck: (data:any, initToken?: string) => http("post", apiUrl.Invitation.checkInvitation, data, { initToken }),
    getUser: (data:any) => http("get", apiUrl.User.getCurrentUser(data)),
    getCurrentUserAccount: (data:any) => http("get", apiUrl.User.getCurrentUserAccounts(data)),
    deleteCurrentUser: (data:any) => http("delete", apiUrl.User.getCurrentUser(data)),
    upDateUserInfo: (data:any) => http("put", apiUrl.User.getCurrentUser(data), data),
  },
  Customer: {
    createCustomer: (data:any) => http("post", apiUrl.AccountApiList.createCustomer, data),
    CIDlist: (data:any) => http("post", apiUrl.AccountApiList.getCIDList, data),
    CIDDefault: (data:any) => http("post", apiUrl.AccountApiList.setDefaultCID, data),
    getAccountList: (data:any) => http("get", apiUrl.Customer.currentCustomerAccountList(data)),
    getUserInfo: (data:any) => http("get", apiUrl.Customer.getUsers(data)),
    customerSelect: (data:any) => http("post", apiUrl.Customer.customerSelect(data)),
    getCurrentCustomer: (data:any) => http("get", apiUrl.Customer.getCustomer(data)),
    putCurrentCustomer: (data:any) => http("put", apiUrl.Customer.getCustomer(data), data),
    deleteCustomerDefault: (data:any) => http("delete", apiUrl.Customer.deleteDefault, data)
  },
  Account: {
    createAccount: (data:any) => http("post", apiUrl.AccountApiList.createAccount, data),
    getAccount: (data:any) => http("get", apiUrl.AccountApiList.getAccount(data)),
    editAccount: (data:any) => http("put", apiUrl.AccountApiList.editAccount(data), data),
    deleteAccount: (data:any) => http("delete", apiUrl.AccountApiList.editAccount(data)),
  },
  Campaign: {
    getCampaignList: (data:any) => http("get", apiUrl.Campaign.getCampaignList(data)),
    getUnitList: (data:any) => http("get", apiUrl.Campaign.getUnitList(data)),
    postStartUnit: (data:any) => http("post", apiUrl.Campaign.postStartUnit, data),
    postStopUnit: (data:any) => http("post", apiUrl.Campaign.postStopUnit, data),
    postStopUnitImmediately: (data:any) => http("post", apiUrl.Campaign.postStopUnitImmediately, data),
    postSystemStartUnit: (data:any) => http("post", apiUrl.Campaign.postSystemStartUnit, data),
    postSystemStopUnit: (data:any) => http("post", apiUrl.Campaign.postSystemStopUnit, data),
    postUpdateCampaignName: (data:any) => http("post", apiUrl.Campaign.postUpdateCampaignName, data),
    postUpdateUnitName: (data:any) => http("post", apiUrl.Campaign.postUpdateUnitName, data),
    GetValidatedCampaignList: (data:any) => http("get", apiUrl.Campaign.GetValidatedCampaignList(data)),
    GetAdCreativeResult: (data:any) => http("get", apiUrl.Campaign.GetAdCreativeResult(data)),
    GetUnitReport: (data:any) => http("get", apiUrl.Campaign.GetUnitReport(data))
  },
  Qualification: {
    getQualicationItems: (data: any) => http("get", apiUrl.Qualification.getQualificationItems(data)),
    getMultiplableQualificationCategories: () => http("get", apiUrl.Qualification.getMultiplableQualificationCategories()),
    handleFile: (param: any, data: FormData) => http("post", apiUrl.Qualification.handleFile(param), data, {
      headers: {
        "Accept": "*/*",
        "Content-Type": "multipart/form-data"
      }
    }),
    getQualificationIndustry: (data: any) => http("get", apiUrl.Qualification.getQualificationIndustry(data)),
    getQualificationDetail: (data: any) => http("get", apiUrl.Qualification.getQualificationDetail(data)),
    updateMainQuailification: (param: any, data: any) => http("post", apiUrl.Qualification.updateMainQuailification(param), data),
    addQuailification: (param: any, data: any) => http("post", apiUrl.Qualification.addQuailification(param), data),
    updateQuailification: (param: any, data: any) => http("post", apiUrl.Qualification.updateQuailification(param), data),
    deleteQualification: (data:any) => http("delete", apiUrl.Qualification.deleteQualification(data)),
    getNextaction: (param: any) => http("get", apiUrl.Qualification.getNextaction(param))
  },
  AdCreativeForm: {
    getCampaignCenterList: (data:any) => http("get", apiUrl.AdCreativeForm.getCampaignCenterList(data), data),
    getSingleCampaign: (data:any) => http("get", apiUrl.AdCreativeForm.singleCampaignCampaignCenter(data)),
    createCampaign: (data:any) => http("post", apiUrl.AdCreativeForm.createCampaign, data, {
      headers: {
        "Accept": "*/*",
        "Content-Type": "multipart/form-data"
      }
    }),
    updateCampaign: (data:any) => http("put", apiUrl.AdCreativeForm.editCampaignCenter(data), data, {
      headers: {
        "Accept": "*/*",
        "Content-Type": "multipart/form-data"
      }
    }),
    updateCampaignName: (data:any) => http("put", apiUrl.AdCreativeForm.updateCampaignName(data), data),
    deleteCampaign: (data:any) => http("delete", apiUrl.AdCreativeForm.deleteCampaignCenter(data)),
    downloadUserCampaign: (data:any) => http("get", apiUrl.AdCreativeForm.downloadUserCampaign(data), data, {
      responseType: "blob"
    }),
    deliver: (data:any) => http("get", apiUrl.AdCreativeForm.deliver(data)),
    preview: (data:any) => http("get", apiUrl.AdCreativeForm.preview(data)),
    getValidAdCreatives: (data:any) => http("get", apiUrl.AdCreativeForm.GetValidAdCreatives(data)),
    getTemplateList: () => http("get", apiUrl.AdCreativeForm.getTemplateList),
    GetInquiryOrders: (data:any) => http("get", apiUrl.AdCreativeForm.GetInquiryOrders(data)),
    GetAdCreativeForm: (data:any) => http("get", apiUrl.AdCreativeForm.GetAdCreativeForm(data)),
    GetAdCreative: (data:any) => http("get", apiUrl.AdCreativeForm.GetAdCreative(data)),
    Getgrouptemplate: (data:any) => http("get", apiUrl.AdCreativeForm.grouptemplate(data)),
    GetTemplateChild: (data:any) => http("get", apiUrl.AdCreativeForm.getTemplateChild(data)),
    updateName: (data:any) => http("post", apiUrl.AdCreativeForm.updateName, data),
    IsReadyToCreate: (data:any) => http("get", apiUrl.AdCreativeForm.IsReadyToCreate(data)),
    Warn: (data:any) => http("get", apiUrl.AdCreativeForm.Warn(data)),
    UploadImage: (data:any) => http("post", apiUrl.AdCreativeForm.UploadImage(data), data, {
      headers: {
        "Accept": "*/*",
        "Content-Type": "multipart/form-data"
      }
    }),
    UploadVideo: (data:any) => http("post", apiUrl.AdCreativeForm.UploadVideo(data), data, {
      headers: {
        "Accept": "*/*",
        "Content-Type": "multipart/form-data"
      }
    }),
    GetExtraTemplateList: (data:any) => http("get", apiUrl.AdCreativeForm.GetExtraTemplateList(data)),
    GetSuperBrandCardInfoList: () => http("get", apiUrl.AdCreativeForm.GetSuperBrandCardInfoList)
  },
  UnitAdCreative: {
    getUnitAdCreative: (data:any) => http("post", apiUrl.UnitAdCreative.getUnitAdCreative, data),
    createUnitAdCreative: (data:any) => http("post", apiUrl.UnitAdCreative.createUnitAdCreative, data),
    updateUnitAdCreative: (data:any) => http("put", apiUrl.UnitAdCreative.updateUnitAdCreative(data), data),
    editUnitAdCreative: (data:any) => http("put", apiUrl.UnitAdCreative.editUnitAdCreative(data), data),
    deleteUnitAdCreative: (data:any) => http("delete", apiUrl.UnitAdCreative.deleteUnitAdCreative(data), data),
    previewUnitAdCreative: (data:any) => http("get", apiUrl.UnitAdCreative.previewUnitAdCreative(data), data),
    getValidTimesForAdd: (data:any) => http("get", apiUrl.UnitAdCreative.getValidTimesForAdd(data)),
    getValidTimesForEdit: (data:any) => http("get", apiUrl.UnitAdCreative.getValidTimesForEdit(data), data),
    reportdemo: (data:any) => http("get", apiUrl.UnitAdCreative.reportdemo, data),
    getCampaignList: (data:any) => http("get", apiUrl.UnitAdCreative.getCampaignList(data), data),
    updateName: (data:any) => http("post", apiUrl.UnitAdCreative.UpdateName, data),
    getUnitAdCreativeReport: (data:any) => http("get", apiUrl.UnitAdCreative.getUnitAdCreativeReport(data)),
    getMatchedForCreativeWithUnit: (data:any) => http("get", apiUrl.UnitAdCreative.getMatchedForCreativeWithUnit(data)),
  },
  Ket: {
    getHistory: (data: any) => http("get", apiUrl.Ket.getHistory(data)),
    getById: (data: any) => http("get", apiUrl.Ket.getById(data)),
    view: (data: any) => http("get", apiUrl.Ket.view(data)),
    download: (data: any) => http("get", apiUrl.Ket.download(data), data, {
      responseType: "blob"
    }),
    delete: (data: any) => http("delete", apiUrl.Ket.delete(data)),
    search: (data: any) => http("post", apiUrl.Ket.search, data),
    estimate: (data: any) => http("post", apiUrl.Ket.estimate, data),
  },
  Inquiry: {
    getAccountInquiryStatus: (data: any) => http("get", apiUrl.Inquiry.getAccountInquiryStatus(data), data),
    getInquiryList: (data: any) => http("get", apiUrl.Inquiry.getInquiryList(data), data),
    creativeInquiry: (data: any) => http("post", apiUrl.Inquiry.creativeInquiry(data), data),
    dealInquiryList: (data: any) => http("post", apiUrl.Inquiry.dealInquiryList(data), data.agency),
    currentInquiryInfo: (data: any) => http("get", apiUrl.Inquiry.getCurrentInquiry(data)),
    getInquiryoptions: (data:any) => http("get", apiUrl.Inquiry.getInquiryoptions(data)),
    deleteCurrentInquiry: (data:any) => http("post", apiUrl.Inquiry.deleteCurrentInquiry(data)),
    abandonCurrentInquiry: (data:any) => http("post", apiUrl.Inquiry.abandonCurrentInquiry(data)),
    getInquiryDetail: (data: any) => http("get", apiUrl.Inquiry.getInquiryDetail(data), data),
    getOrderDetail: (data: any) => http("get", apiUrl.Inquiry.getOrderDetail(data), data),
    editInquiry: (data:any) => http("post", apiUrl.Inquiry.editInquiry(data), data),
    draftInquiry: (data:any) => http("post", apiUrl.Inquiry.draftInquiry(data), data),
    DownloadInquiryorderdetailbyCID: (params: any) => http("get", apiUrl.Inquiry.DownloadinquiryorderdetailbyCID(params), {}, {
      responseType: "blob"
    }),
  },
  Report: {
    ready: (data:any) => http("get", apiUrl.Report.ready(data)),
    dataready: (data:any) => http("get", apiUrl.Report.dataready(data)),
    getAccountReportList: (data:any) => http("get", apiUrl.Report.getAccountReportList(data)),
    getCampaignReport: (data:any) => http("get", apiUrl.Report.getCampaignReport(data)),
    getCampaignUnitReport: (data: any) => http("get", apiUrl.Report.getCampaignUnitReport(data)),
    getUnitAdCreativeReport: (data:any) => http("get", apiUrl.Report.getUnitAdCreativeReport(data)),
    getURLClickReport: (data:any) => http("get", apiUrl.Report.getURLClickReport(data)),
    getOrderReport: (data:any) => http("get", apiUrl.Report.getOrderReport(data)),
    getKeywordReport: (data:any) => http("get", apiUrl.Report.getKeywordReport(data)),
    getTemplateReport: (data:any) => http("get", apiUrl.Report.getTemplateReport(data)),
    getMonthlyReport: (data:any) => http("get", apiUrl.Report.getMonthlyReport(data)),
    downloadAccountReport: (data:any) => http("get", apiUrl.Report.downloadAccountReport(data), {}, {
      responseType: "blob"
    }),
    downloadCampaignReport: (data:any) => http("get", apiUrl.Report.downloadCampaignReport(data), {}, {
      responseType: "blob"
    }),
    downloadCampaignUnitReport: (data:any) => http("get", apiUrl.Report.downloadCampaignUnitReport(data), {}, {
      responseType: "blob"
    }),
    downloadUnitAdCreativeReport: (data:any) => http("get", apiUrl.Report.downloadUnitAdCreativeReport(data), {}, {
      responseType: "blob"
    }),
    downloadURLClickReport: (data:any) => http("get", apiUrl.Report.downloadURLClickReport(data), {}, {
      responseType: "blob"
    }),
    downloadOrderReport: (data:any) => http("get", apiUrl.Report.downloadOrderReport(data), {}, {
      responseType: "blob"
    }),
    downloadKeywordReport: (data:any) => http("get", apiUrl.Report.downloadKeywordReport(data), {}, {
      responseType: "blob"
    }),
    downloadTemplateReport: (data:any) => http("get", apiUrl.Report.downloadTemplateReport(data), {}, {
      responseType: "blob"
    }),
    downloadMonthlyReport: (data:any) => http("get", apiUrl.Report.downloadMonthlyReport(data), {}, {
      responseType: "blob"
    }),
    getExtraReport: (data:any) => http("get", apiUrl.Report.extraReport(data)),
    downloadExtraReport: (data:any) => http("get", apiUrl.Report.downloadExtraReport(data), {}, {
      responseType: "blob"
    }),
    inquiryTabControl: (data:any) => http("get", apiUrl.Report.inquiryTabControl(data)),
  },
  Dashboard: {
    getCustomerReport: (data:any) => http("get", apiUrl.Dashboard.getCustomerReport(data)),
    getCustomerDetaileReport: (data:any) => http("get", apiUrl.Dashboard.getCustomerDetaileport(data)),
    getAccountReport: (data:any) => http("get", apiUrl.Dashboard.getAccountReport(data)),
    getAccountDetailReport: (data:any) => http("get", apiUrl.Dashboard.getAccountDetaileport(data)),
    getInqueryReport: (data:any) => http("get", apiUrl.Dashboard.getInqueryData(data)),
    getCampaignReport: (data:any) => http("get", apiUrl.Dashboard.getCampaignData, data),
  },
  Feedback: {
    submitFeedback: (data: any) => http("post", apiUrl.Feedback.submitFeedback, data),
    uploadFile: (data: FormData) => http("post", apiUrl.Feedback.uploadFile, data, {
      headers: {
        "Accept": "*/*",
        "Content-Type": "multipart/form-data"
      }
    }),
  },
  AgencyManagement: {
    Orders: {
      getInquirylist: (params: any, data: any) => http("get", apiUrl.agencyManagement.Orders.getInquirylist(params), data),
      getOrderList: (params: any, data: any) => http("get", apiUrl.agencyManagement.Orders.getOrderList(params), data),
      getInquiryOrderDetail: (params: any) => http("get", apiUrl.agencyManagement.Orders.getInquiryOrderDetail(params)),
      getOrderDetail: (params: any) => http("get", apiUrl.agencyManagement.Orders.getOrderDetail(params)),
      OrderDeal: (params: any) => http("post", apiUrl.agencyManagement.Orders.OrderDeal(params), params),
      OrderAbandoninquiryorder: (params: any) => http("post", apiUrl.agencyManagement.Orders.OrderAbandoninquiryorder(params), params),
      DownloadInquiryorderdetail: (params: any) => http("get", apiUrl.agencyManagement.Orders.Downloadinquiryorderdetail(params), {}, {
        responseType: "blob"
      }),
      DownloadInquiryorderForAgency: (params: any) => http("get", apiUrl.agencyManagement.Orders.DownloadinquiryorderAgency(params), {}, {
        responseType: "blob"
      }),
      DownloadorderForAgency: (params: any) => http("get", apiUrl.agencyManagement.Orders.DownloadorderAgency(params), {}, {
        responseType: "blob"
      }),
      Temporarycancellationorderids: () => http("get", apiUrl.agencyManagement.Orders.Temporarycancellationorderids)
    },
    RealBill: {
      getList: (params: any) => http("get", apiUrl.agencyManagement.RealBill.getList(params)),
      download: (params: any) => http("get", apiUrl.agencyManagement.RealBill.download(params), {}, {
        responseType: "blob"
      }),
      getGlobalList: (params: any) => http("get", apiUrl.agencyManagement.RealBill.getGlobalList(params)),
    }
  },
  LeadGen: {
    CampaignUnitAdCreative: {
      getUnitAdCreativeList: (data: any) => http("get", apiUrl.LeadGen.CampaignUnitAdCreative.getCampaignUnitAdCreativeList(data), data),
      getUnitAdCreative: (data: any) => http("get", apiUrl.LeadGen.CampaignUnitAdCreative.getCampaignUnitAdCreative(data), data),
      creativerAdCreative: (data: any) => http("post", apiUrl.LeadGen.CampaignUnitAdCreative.createCampaignUnitAdCreative, data),
      updateName: (data: any) => http("post", apiUrl.LeadGen.CampaignUnitAdCreative.updateName(data), data),
      deleteUnitAdCreative: (data: any) => http("delete", apiUrl.LeadGen.CampaignUnitAdCreative.deleteCampaignUnitAdCreative(data), data),
      reviewUnitAdCreative: (data: any) => http("get", apiUrl.LeadGen.CampaignUnitAdCreative.reviewCampaignUnitAdCreative(data), data),
      downloadFileContent: (data:any) => http("get", apiUrl.LeadGen.CampaignUnitAdCreative.downloadFileContent(data), data, {
        responseType: "blob"
      }),
      uploadFile: (params: any, data: FormData) => http("post", apiUrl.LeadGen.CampaignUnitAdCreative.uploadFile(params), data, {
        headers: {
          "Accept": "*/*",
          "Content-Type": "multipart/form-data"
        }
      }),
      deleteFile: (data: any) => http("delete", apiUrl.LeadGen.CampaignUnitAdCreative.deleteFile(data)),
      getUnitAdCreativeOptions: (data: any) => http("get", apiUrl.LeadGen.CampaignUnitAdCreative.getOptions(data)),
      createCampaignUnitAdCreativeFrom: (data: any) => http("post", apiUrl.LeadGen.CampaignUnitAdCreative.createCampaignUnitAdCreativeFrom, data, {
        headers: {
          "Accept": "*/*",
          "Content-Type": "multipart/form-data"
        }
      }),
    },
    Campaign: {
      getCampaignList: (data: any) => http("get", apiUrl.LeadGen.Campaign.getCampaignList(data), data),
      createCampaign: (data: any) => http("post", apiUrl.LeadGen.Campaign.createCampaign(data), data),
      deleteCampaign: (data: any) => http("delete", apiUrl.LeadGen.Campaign.deleteCampaign(data)),
      getCreationoptions: (data: any) => http("get", apiUrl.LeadGen.Campaign.getCreationoptions(data), data),
      updateName: (data: any) => http("put", apiUrl.LeadGen.Campaign.updateName(data)),
    },
    CampaignUnit: {
      getUnitList: (data: any) => http("get", apiUrl.LeadGen.CampaignUnit.getCampaignUnitList(data), data),
      createUnit: (params: any, data: any) => http("post", apiUrl.LeadGen.CampaignUnit.createCampaignUnit(params), data),
      deleteUnit: (data: any) => http("delete", apiUrl.LeadGen.CampaignUnit.deleteCampaignUnit(data)),
      getcreationoptions: (data: any) => http("get", apiUrl.LeadGen.CampaignUnit.getCampaignunitcreationoptions(data)),
      updateName: (data: any) => http("put", apiUrl.LeadGen.CampaignUnit.updateName(data)),
      preview: (data: any) => http("get", apiUrl.LeadGen.CampaignUnit.preview(data)),
    },
    BillingReport: {
      getList: (data: any) => http("get", apiUrl.LeadGen.BillingReport.getList, data),
      downloadItem: (data: any) => http("get", apiUrl.LeadGen.BillingReport.downloadItem(data.id), {}, {
        responseType: "blob"
      }),
      getPreviewList: (data: any) => http("get", apiUrl.LeadGen.BillingReport.getPreviewList(data.id)),
      getItemsDetail: (data: any) => http("get", apiUrl.LeadGen.BillingReport.getItemsDetail(data.id)),
      editItemsDetail: (data: any, id: any) => http("put", apiUrl.LeadGen.BillingReport.editItemsDetail(id), data, {
        headers: {
          "Accept": "*/*",
          "Content-Type": "multipart/form-data"
        }
      }),
      submitItemDatas: (data: any) => http("put", apiUrl.LeadGen.BillingReport.submitItemDatas(data.id)),
      getBillingSummary: (data: any) => http("get", apiUrl.LeadGen.BillingReport.getBillingSummary(data.id)),
    },
    AccrualReport: {
      getList: (data: any) => http("get", apiUrl.LeadGen.AccrualReport.getList, data),
      downloadItem: (data: any) => http("get", apiUrl.LeadGen.AccrualReport.downloadItem(data.id), {}, {
        responseType: "blob"
      }),
      getPreviewList: (data: any) => http("get", apiUrl.LeadGen.AccrualReport.getPreviewList(data.id)),
      getItemsDetail: (data: any) => http("get", apiUrl.LeadGen.AccrualReport.getItemsDetail(data.id)),
      editItemsDetail: (data: any, id: any) => http("put", apiUrl.LeadGen.AccrualReport.editItemsDetail(id), data, {
        headers: {
          "Accept": "*/*",
          "Content-Type": "multipart/form-data"
        }
      }),
      submitItemDatas: (id: any, data: any) => http("put", apiUrl.LeadGen.AccrualReport.submitItemDatas(id), data, {
        headers: {
          "Accept": "*/*",
          "Content-Type": "multipart/form-data"
        }
      }),
      getBillingSummary: (data: any) => http("get", apiUrl.LeadGen.AccrualReport.getBillingSummary(data.id), { exchangeRate: data.exchangeRate }),
    }
  },
  GetDoc: {
    getHelpDoc: (data: any) => http("get", apiUrl.GetDoc.getHelpDoc(data.productType), data, {
      responseType: "blob"
    }),
    getTemplateZip: (data:any) => http("get", apiUrl.GetDoc.getTemplateZip(data), data, {
      responseType: "blob"
    }),
    getTemplatePic: (data:any) => http("get", apiUrl.GetDoc.getTemplatePic(data), data, {
      responseType: "blob"
    })
  },
  CrossBorder: {
    getEndpoint: (data:any) => http("get", apiUrl.CrossBorder.getEndpoint, data),
    getUserInfo: (data:any) => http("get", apiUrl.CrossBorder.getGraphUserInfo, data),
    // refreshUserInfo: (data:any) => http("get", apiUrl.CrossBorder.refreshgetGraphUserInfo, data),
    getMAPAccountList: (data:any) => http("get", apiUrl.CrossBorder.getMAPAccountList, data),
    asyncAccount: (data:any) => http("post", apiUrl.CrossBorder.asyncAccount, data),
    getMAPAccount: (data:any) => http("get", apiUrl.CrossBorder.getMAPAccount(data)),
    getMAPAccountStatus: (data:any) => http("get", apiUrl.CrossBorder.getMAPAccountStatus(data)),
    getMAPAgreement: (data:any) => http("get", apiUrl.CrossBorder.getMAPAgreement(data)),
    getOrderpausereason: (data:any) => http("get", apiUrl.CrossBorder.getOrderpausereason(data)),
  },
  StoreAdsCPT: {
    StoreAdsMaterial: {
      getMaterialList: (data: any) => http("get", apiUrl.StoreAdsCPT.StoreAdsMaterial.getMaterialList(data), data),
      getMaterialDetail: (data:any) => http("get", apiUrl.StoreAdsCPT.StoreAdsMaterial.getMaterialDetail(data)),
      createMaterial: (data:any) => http("post", apiUrl.StoreAdsCPT.StoreAdsMaterial.createMaterial, data),
      deleteMaterial: (data:any) => http("delete", apiUrl.StoreAdsCPT.StoreAdsMaterial.deleteMaterial(data)),
      uploadMaterialImage: (data: any) => http("post", apiUrl.StoreAdsCPT.StoreAdsMaterial.uploadMaterialImageFile(data.aid), data, {
        headers: {
          "Accept": "*/*",
          "Content-Type": "multipart/form-data"
        }
      }),
      bindMaterial: (data: any) => http("post", apiUrl.StoreAdsCPT.StoreAdsMaterial.bindMaterial, data),
    }
  },
  StoreAds: {
    getPositionStock: (data: any) => http("get", apiUrl.StoreAds.getPositionStock, data),
    getOrderList: (data: any) => http("get", apiUrl.StoreAds.getOrderList(data.accountId), data),
    getAppOptions: (data: any) => http("get", apiUrl.StoreAds.getAppOptions, data),
    getCandidatePeriods: (data: any) => http("get", apiUrl.StoreAds.getCandidatePeriods, data),
    getCouponOptions: (data: any) => http("get", apiUrl.StoreAds.getCouponOptions, data),
    getCouponPrice: (data: any) => http("get", apiUrl.StoreAds.getCouponPrice, data),
    createOrder: (data: any) => http("post", apiUrl.StoreAds.createOrder(data), data),
    getMaterialsByOrder: (data: any) => http("get", apiUrl.StoreAds.getMaterialsByOrderList(data.orderId), data),
  }
};

export default api;
